/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Select_File_LabelInputs */



/**
* | output |
* | --- |
* | "Select Transcript File" |
*
* @param {Plain_Text_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_select_file_label = /** @type {((inputs?: Plain_Text_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner le fichier de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkriptdatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il file di trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл стенограммы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择成绩单文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख फ़ाइल का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo de transcrição")
	return /** @type {LocalizedString} */ ("Select Transcript File")
});